import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
    SalesIndentMasterCreateRequestDTO,
    SalesIndentMasterDeleteRequestDTO,
    SalesIndentMasterDTO,
    SalesIndentMasterList,
    SalesIndentMasterReadByIdRequestDTO,
    SalesIndentMasterReadByTenantRequestDTO,
    SalesIndentMasterSearchByIndentNoRequestDTO,
    SalesIndentMasterUpdateRequestDTO
} from "./indent-master.interface";

import {
    SalesIndentMaster_Create,
    SalesIndentMaster_Update,
    SalesIndentMaster_Delete,
    SalesIndentMaster_ReadById,
    SalesIndentMaster_ReadAll,
    SalesIndentMaster_ReadByTenantId,
    SalesIndentMaster_SearchByIndentNo
} from "src/app/GlobalVariables";


@Injectable({ providedIn: 'root' })
export class SalesIndentMasterService {

    http = inject(HttpClient);


    /*** Create Sales Indent Master */
    SalesIndentMaster_Create(data: SalesIndentMasterCreateRequestDTO): Observable<SalesIndentMasterDTO> {
        return this.http.post<SalesIndentMasterDTO>(SalesIndentMaster_Create, data);
    }


    /*** Update Sales Indent Master */
    SalesIndentMaster_Update(data: SalesIndentMasterUpdateRequestDTO): Observable<SalesIndentMasterDTO> {
        return this.http.post<SalesIndentMasterDTO>(SalesIndentMaster_Update, data);
    }


    /*** Delete Sales Indent Master */
    SalesIndentMaster_Delete(data: SalesIndentMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesIndentMaster_Delete, data);
    }


    /*** Read By Id */
    SalesIndentMaster_ReadById(data: SalesIndentMasterReadByIdRequestDTO): Observable<SalesIndentMasterDTO> {
        return this.http.post<SalesIndentMasterDTO>(SalesIndentMaster_ReadById, data);
    }


    /*** Read All */
    SalesIndentMaster_ReadAll(): Observable<SalesIndentMasterDTO> {
        return this.http.get<SalesIndentMasterDTO>(SalesIndentMaster_ReadAll);
    }


    /*** Read By Tenant */
    SalesIndentMaster_ReadByTenantId(data: SalesIndentMasterReadByTenantRequestDTO): Observable<SalesIndentMasterDTO> {
        return this.http.post<SalesIndentMasterDTO>(SalesIndentMaster_ReadByTenantId, data);
    }


    /*** Search By Indent No */
    SalesIndentMaster_SearchByIndentNo(data: SalesIndentMasterSearchByIndentNoRequestDTO): Observable<SalesIndentMasterList> {
        return this.http.post<SalesIndentMasterList>(SalesIndentMaster_SearchByIndentNo, data);
    }

}